import React, { useState, useEffect } from 'react'

const GoogleMapView = (props) => {
    const [coords, setCoords] = useState(props.googleMap.marker[0].coords)
    const [polygonPath, setPolygonPath] = useState(props.googleMap.polygonPath)
    const [googleMap, setGoogleMap] = useState(props.googleMap)

    /* Map */
    const Start = () => {
        var map
        const mapDiv = document.getElementById('map')
        const googleScript = document.getElementById('google-map-script')

        if (window.google) {
            map = new window.google.maps.Map(mapDiv, {
                zoom: 17,
                center: { lat: coords[0], lng: coords[1] },
                mapTypeId: 'hybrid'
            });

            /* Polygon coords */
            var estateCoords = []
            polygonPath.map((item) => {
                estateCoords = [...estateCoords, { lat: item[0], lng: item[1] }]
                return estateCoords
            })

            /* Construct polygon */
            var estatePoly = new window.google.maps.Polygon({
                paths: estateCoords,
                strokeColor: '#FF0000',
                strokeOpacity: 0.8,
                strokeWeight: 3,
                fillColor: '#FF0000',
                fillOpacity: 0.35,
                editable: props.editable
            });
            estatePoly.setMap(map);
            estatePoly.addListener('mouseup', () => {
                var vertices = estatePoly.getPath();
                var poligono = []

                /* Iterate vertices */
                for (var i = 0; i < vertices.getLength(); i++) {
                    var xy = vertices.getAt(i);
                    poligono = [...poligono, [xy.lat(), xy.lng()]]
                    setPolygonPath(poligono)
                }
            })

            /* Show info window */
            var infowindow = new window.google.maps.InfoWindow({
                content: props.googleMap.marker[0].info
            });

            /* Show placemark */
            var marker = new window.google.maps.Marker({
                position: { lat: coords[0], lng: coords[1] },
                map: map,
                draggable: props.draggable,
                title: props.googleMap.marker[0].info
            });
            marker.setMap(map);
            infowindow.open(map, marker);
            marker.addListener('click', function () {
                infowindow.open(map, marker);
            });
            marker.addListener('mouseup', () => {
                setCoords([marker.getPosition().lat(), marker.getPosition().lng()])
            })

            googleScript.addEventListener('load', () => {
            })
        }


    }

    /* googMap handler */
    const UpdateMap = () => {
        setGoogleMap(
            {
                polygonPath,
                marker: [{ info: props.googleMap.marker[0].info, coords: coords }]

            }
        )
    }

    /* Effects*/
    useEffect(() => {
        Start()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        UpdateMap()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [polygonPath, coords])

    useEffect(() => {
        props.SetGoogleMap(googleMap)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [googleMap]
    )

    return (
        <>
            <div id="map" style={{ height: '100%', width: '100%' }}></div>
        </>
    )
}
export default GoogleMapView